import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Environment, EnvironmentTree } from 'src/components/shared-components/class/general-classes/environment';
import { SmartComponent } from 'src/components/shared-components/class/smart-components/smart-component';
import { SmartComponentEnvironmentAssociated } from 'src/components/shared-components/class/smart-components/smart-component-environment-associated';
import { EnvironmentCategory } from 'src/components/shared-components/enum/enumEnvironment';
import { User } from 'src/model/class/general classes/user';

/**
 * Service to hide data if logged user is root
 */
@Injectable({
    providedIn: 'root'
})
export class HideDataService {
    public isDataHidden: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public envOriginalData: BehaviorSubject<Environment[]> = new BehaviorSubject([]);
    public envAssociatedOriginalData: BehaviorSubject<SmartComponentEnvironmentAssociated[]> = new BehaviorSubject([]);
    public userOriginalData: BehaviorSubject<User[]> = new BehaviorSubject([]);
    public userSelectedOriginalData: BehaviorSubject<User[]> = new BehaviorSubject([]);

    ngOnInit() {
    }

    /**
     * Hide environments data for hidden data mode
     * @returns Array of environments
     */
    public hideEnvironmentsData(): Environment[] {
        const envList = this.envOriginalData.value.map((item: Environment) => {
            if (item.category === EnvironmentCategory.APARTAMENT) {
                return { ...item, customDescription: "**********", descriptionEnvironment: "**********", nRoom: "**********", translatedNRoom: "**********" }
            }
            return item;
        })
        return envList;
    }

    /**
     * Hide environments data for hidden data mode for associated environments elaborated list with composite name parent + children environment
     * @returns Array of environments
     */
    public hideAssociatedEnvironmentsElaboratedData(): SmartComponentEnvironmentAssociated[] {
        const envList = this.envAssociatedOriginalData.value.map((item: SmartComponentEnvironmentAssociated) => {
            return { ...item, environmentName: "**********" }
        })
        return envList;
    }

    /**
   * Hide environments data for hidden data mode for elaborated list with composite name parent + children environment
   * @returns Array of environments
   */
    public hideEnvironmentsElaboratedData(): Environment[] {
        const envList = this.envOriginalData.value.map((item: Environment) => {
            return { ...item, customDescription: "**********", descriptionEnvironment: "**********", nRoom: "**********", translatedNRoom: "**********" }
        })
        return envList;
    }

    /**
     * Hide data if list is of type EnvironmentTree
     * @param listEnvironment 
     * @returns list with hidden data
     */
    public hideEnvironmentsTreeData(
        listEnvironment: EnvironmentTree[]
    ): EnvironmentTree[] {
        if (!listEnvironment || listEnvironment.length === 0) {
            return [];
        }
        return listEnvironment.map((item: EnvironmentTree) => {
            const shouldMask = item.category === EnvironmentCategory.APARTAMENT;
            const maskedItem: EnvironmentTree = {
                ...item,
                ...(shouldMask && {
                    customDescription: "**********",
                    descriptionEnvironment: "**********",
                    nRoom: "**********",
                    translatedNRoom: "**********",
                }),
                children: this.hideEnvironmentsTreeData(item.children || []),
            };
            return maskedItem;
        });
    }

    /**
     * Hide users data for hidden data mode
     * @param nameOfList name of the user list in HideDataService, possible values: userOriginalData, userSelectedOriginalData 
     * @returns Array of users
     */
    public hideUsersData(nameOfList: "userOriginalData" | "userSelectedOriginalData"): User[] {
        const usersList = this[nameOfList].value.map((item: User) => {
            return { ...item, name: "**********", surname: "**********", username: "**********" }
        })
        return usersList;
    }
}